import React from "react";
import constants from "../constants";
import RelayerUtils from "../relayers/RelayerUtils";
import LogoUtils from "../util/LogoUtils";
import RespUtils from "../util/RespUtils";
import SPUtilities from "../util/SPUtilities";

import "./Chains.css";

class Chains extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.chains) {
        return "";
    }

    let chainsRelayed = this.props.chains.split(",");
    // console.log(chainsRelayed);
    let label = this.props.label === true ? true : false;

    let index = 0;
    let size = RespUtils.isTabletView() ? 20 : 32;
    return (
      <div className="wrapper">
        {chainsRelayed.map((chain) => (
            <a key={chain} href={this.getChainLink(chain, this.props.chainConfig)} className="animLink iconLink">
                <img onError={LogoUtils.addDefaultSrc} className="icon" style={{"zIndex": index++}}
                    width={size} height={size} src={this.getChainLogo(chain, this.props.chainConfig)} />
                {label === true && (<span> {chain}</span>)}
            </a>
        ))}{this.props.status != null && RelayerUtils.getChainStatus(this.props.status)}
      </div>
    );
  }

  getChainLogo(chain, chainConfig) {
    if (!chainConfig || !(chain in chainConfig)) {
      // console.log("logo not found for " + chain);
      return "";
    }

    if (chainConfig[chain].logo && chainConfig[chain].logo.toLowerCase().startsWith("http")) {
      return chainConfig[chain].logo;
    }

    let logoPath = constants.PROJECT_LOGO_BASE_URL + "chains/" + chainConfig[chain].logo;
    // console.log(logoPath);

    return logoPath;
  }
  
  getChainLink(chain, chainConfig) {
    if (!chainConfig || !(chain in chainConfig)) {
      // console.log("link not found for " + chain);
      return "";
    }

    let chainDetails = chainConfig[chain];

    let linkPath = "";

    if (this.props.relay === true) {
      linkPath = "/network/" + chain;
    } else if (chainDetails.dashboard != null) {
      linkPath = SPUtilities.getUrl(chainDetails.dashboard);
    }

    return linkPath;
  }
  
}

export default Chains;
